import {
    Component, ChangeDetectionStrategy, Output,
    EventEmitter, Input, OnChanges, SimpleChanges
} from '@angular/core';
import {
    DailyData, MonthlyData, SelectItem,
    SelectedItemList, WeeklyData
} from '../../interfaces/filter-data';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';


@Component({
    selector: 'app-schedule-report',
    template: require('./schedule-report.component.html'),
    styles: [require('./schedule-report.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ScheduleReportComponent implements OnChanges {

    @Input()
    public selectedFilters: SelectedItemList;

    @Output()
    public onScheduleChange: EventEmitter<{}> = new EventEmitter<{}>();

    public scheduleTypes: SelectItem[] = [
        { id: 1, name: 'Daily' },
        { id: 2, name: 'Weekly' },
        { id: 3, name: 'Monthly' },
        // { id: 4, name: 'One Time Only?', isDisabled: true }
    ];

    public weekdayItems: SelectItem[] = [
        { id: 1, name: 'Sunday' },
        { id: 2, name: 'Monday' },
        { id: 3, name: 'Tuesday' },
        { id: 4, name: 'Wednesday' },
        { id: 5, name: 'Thursday' },
        { id: 6, name: 'Friday' },
        { id: 7, name: 'Saturday' },
    ];

    public weekItems: SelectItem[] = [
        { id: 1, name: 'First' },
        { id: 2, name: 'Second' },
        { id: 3, name: 'Third' },
        { id: 4, name: 'Fourth' },
        { id: 5, name: 'Last' },
    ];

    public selectedWeekday: SelectItem = {} as SelectItem;
    public selectedWeek: SelectItem = {} as SelectItem;
    public startTime: string;
    public errorMessage: string = null;
    public effectiveDateString: string;
    public infoMessage = 'Some months have fewer than _SELECTED_DAY_ days, For these months, the occurrence will fall on the last day of the month.';
    public showInfoPopup = false;
    public showWeekdayDropdownList = false;
    public showWeekDropdownList = false;
    public selectedScheduleType: SelectItem = { id: 0, name: null };
    public dailyData: DailyData = { isEveryWeekDay: false, days: null };
    public weeklyData: WeeklyData = {} as WeeklyData;
    public monthlyData: MonthlyData = {} as MonthlyData;
    public errorField: number;
    public isInfoMsgAccepted = false;
    constructor() {
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.selectedFilters && this.selectedFilters && this.selectedFilters.reoccurencePattern) {
            this.resetToDefault();
            this.selectedScheduleType = this.scheduleTypes.find(st => st.name.toLowerCase() === this.selectedFilters.reoccurencePattern.toLowerCase());
            this.startTime = new Date(this.selectedFilters.scheduleRunTime).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
            this.setScheduledData();
        }
    }

    public onScheduleTypeChange(schedule: { id: number, name: string }) {
        this.selectedScheduleType = schedule;
        this.resetToDefault();
        this.selectedWeekday = this.getDefaultWeekday();
        this.selectedWeek = this.getDefaultWeek();
    }

    public onDailyOptionChange() {
        this.dailyData.days = null;
        this.errorMessage = null;
        this.errorField = 0;
    }

    public onWeekdayItemChange(item: SelectItem) {
        this.selectedWeekday = item;
        this.getEffectiveDate();
    }

    public onWeekItemChange(item: SelectItem) {
        this.selectedWeek = item;
        this.getEffectiveDate();
    }

    public onInfoActionClick(action: boolean) {
        this.showInfoPopup = false;
        if (action) {
            this.isInfoMsgAccepted = true;
            this.onScheduleActionClick(action);
        }
    }

    public onScheduleActionClick(action: boolean): any {
        this.showInfoPopup = false;
        this.errorMessage = null;
        this.errorField = 0;
        let scheduleParams: any = {};
        let scheduleData: any = {};
        if (action) {
            if (this.selectedScheduleType && this.selectedScheduleType.id) {

                if (this.selectedScheduleType.id === 1 && this.validateDailyData()) {

                    scheduleParams = {
                        daily: JSON.stringify([{
                            frequency: this.dailyData.days || 'weekday'
                        }])
                    };
                }

                if (this.selectedScheduleType.id === 2 && this.validateWeeklyData()) {

                    scheduleParams = {
                        weekly: JSON.stringify([{
                            frequency: this.weeklyData.recureEvery,
                            day: this.selectedWeekday.name
                        }])
                    };

                }

                if (this.selectedScheduleType.id === 3 && this.validateMonthlyData()) {

                    if (this.monthlyData.isDay) {
                        scheduleParams = {
                            monthly: JSON.stringify([{
                                frequency: this.monthlyData.dayNumber,
                                day: this.monthlyData.dayMonth
                            }])
                        };
                    } else {

                        scheduleParams = {
                            monthly: JSON.stringify([{
                                frequency: this.monthlyData.weekMonths,
                                weekday: this.selectedWeekday.name,
                                week: this.selectedWeek.name
                            }])
                        };
                    }

                }

                if (!this.startTime && !this.errorMessage && !this.showInfoPopup) {
                    this.errorMessage = 'Please enter the report start time';
                    this.errorField = 8;
                    return;
                }

                if (scheduleParams && this.startTime && !this.errorMessage) {

                    let reportStartTime = `${new DatePipe('en-US').transform(moment(this.startTime, ['h:mm A']).local(), 'dd-MMM-yy hh:mm:ss a')} ${Intl.DateTimeFormat().resolvedOptions().timeZone}`;

                    scheduleData = {
                        scheduleParams: scheduleParams,
                        scheduleRunTime: reportStartTime,
                        reoccurencePattern: this.selectedScheduleType.name
                    };
                }
            } else {
                this.errorMessage = 'Please select a schedule pattern.';
                return;
            }
        }

        if (!action || (Object.keys(scheduleData).length && Object.keys(scheduleParams).length)) {
            this.selectedScheduleType = {} as SelectItem;
            this.onScheduleChange.emit({ scheduleData, action });
        }
    }

    public onStartTimeSet(time: string) {
        this.startTime = time;
        this.getEffectiveDate();
    }

    public getEffectiveDate(skipValidation = false) {
        let startTime = moment(this.startTime, 'HH:mm a');
        let currentDateTime = moment();
        let isSameOrAfterTime = startTime.isSameOrAfter(currentDateTime);
        if (this.selectedScheduleType.id === 1) {
            if (!skipValidation) {
                this.validateDailyData();
            }
            let currentDay = moment();
            let daysToBeAdd = (currentDay.format('ddd') === 'Fri') ? 3 : (this.dailyData.days || 1);
            if (isSameOrAfterTime) {
                this.effectiveDateString = currentDay.format('ddd MMM DD YYYY');
            } else {
                this.effectiveDateString = currentDay.add(daysToBeAdd, 'days').format('ddd MMM DD YYYY');
            }
        }

        if (this.selectedScheduleType.id === 2) {
            this.validateWeeklyData();
            let selectedDayDate = moment().day(this.selectedWeekday.name);
            let isSameOrAfterDayDate = selectedDayDate.isSameOrAfter(currentDateTime);

            if (isSameOrAfterDayDate && isSameOrAfterTime) {
                this.effectiveDateString = selectedDayDate.format('ddd MMM DD YYYY');
            } else {
                this.effectiveDateString = selectedDayDate.add(this.weeklyData.recureEvery, 'weeks').format('ddd MMM DD YYYY');
            }

        }

        if (this.selectedScheduleType.id === 3) {
            this.validateMonthlyData();
            if (this.monthlyData.isDay) {
                let selectedDay = moment(this.startTime, 'HH:mm a').date(+this.monthlyData.dayNumber);

                let isSameOrAfterDay = selectedDay.clone().isSameOrAfter(currentDateTime);
                let isSameOrAfterMonthTime = selectedDay.clone().isSameOrAfter(currentDateTime);

                if (isSameOrAfterDay && isSameOrAfterMonthTime) {
                    this.effectiveDateString = selectedDay.format('ddd MMM DD YYYY');
                } else {
                    this.effectiveDateString = selectedDay.add(this.monthlyData.dayMonth, 'months').format('ddd MMM DD YYYY');
                }

            } else {
                let selectedMonthDay = moment(this.startTime, 'HH:mm a').add(+this.monthlyData.weekMonths, 'month').startOf('month');
                let count = 0;
                let daysInMonth = selectedMonthDay.clone().daysInMonth();
                let dateTime = '';
                for (let i = 1; i <= daysInMonth; i++) {
                    if (selectedMonthDay.format('dddd') === this.selectedWeekday.name) {
                        count++;
                        dateTime = selectedMonthDay.format('ddd MMM DD YYYY');
                        if (count === +this.selectedWeek.id) {
                            break;
                        }
                    }
                    selectedMonthDay.add(1, 'day');
                }
                this.effectiveDateString = dateTime;
            }
        }
    }

    public verifyDateFormat() {
        const dateRegex = /^(([1-9]|0[1-9]|1[0-2]):[0-5][0-9] ([AaPp][Mm]))$/;
        this.errorField = dateRegex.test(this.startTime) ? 0 : 8;
        this.errorMessage = this.errorField ? 'Please enter the report start time in HH:MM AM/PM format.' : '';
    }

    public clearValidationMsg() {
        this.errorMessage = this.errorField = null;
    }

    private setScheduledData() {
        if (this.selectedScheduleType.id === 1) { 
            const daily = JSON.parse(this.selectedFilters.scheduleFilterContent.daily) as any;
            this.dailyData = {
                isEveryWeekDay: isNaN(daily[0].frequency),
                days: isNaN(daily[0].frequency) ? '' : daily[0].frequency
            };
        }

        if (this.selectedScheduleType.id === 2) {
            const weekly = JSON.parse(this.selectedFilters.scheduleFilterContent.weekly) as any;
            this.weeklyData = {
                recureEvery: weekly[0].frequency,
                weeks: weekly[0].day
            };
            this.selectedWeekday = this.weekdayItems.find(wi => wi.name === weekly[0].day);
        }

        if (this.selectedScheduleType.id === 3) {
            const monthly = JSON.parse(this.selectedFilters.scheduleFilterContent.monthly) as any;
            this.monthlyData = {
                isDay: (!monthly[0].weekday && !monthly[0].week),
                dayNumber: (monthly[0].weekday && monthly[0].week) ? '' : monthly[0].day,
                dayMonth: (monthly[0].weekday && monthly[0].week) ? '' : monthly[0].frequency,
                weekMonths: (monthly[0].weekday && monthly[0].week) ? monthly[0].frequency : '',
                weekDay: monthly[0].weekday,
                weekDayNumber: monthly[0].week,
            };
            this.selectedWeekday = this.weekdayItems.find(wi => wi.name === monthly[0].weekday);
            this.selectedWeek = this.weekItems.find(wi => wi.name === monthly[0].week);
        }
        this.getEffectiveDate();
    }

    private validateDailyData(): boolean {
        this.clearValidationMsg();
        if (Object.keys(this.dailyData).length) {
            if ((!this.dailyData.isEveryWeekDay && !+this.dailyData.days) || isNaN(this.dailyData.days)) {
                this.errorMessage = 'Please enter a valid day(s)';
                this.errorField = 1;
                return false;
            }
        } else {
            this.errorMessage = 'Please select any one of the day option';
            return false;
        }
        return true;
    }

    private validateWeeklyData(): boolean {
        this.clearValidationMsg();
        if (Object.keys(this.weeklyData).length) {
            if (!+this.weeklyData.recureEvery || isNaN(this.weeklyData.recureEvery)) {
                this.errorMessage = 'Please enter a valid number';
                this.errorField = 2;
                return false;
            }

            if (this.selectedWeekday && !this.selectedWeekday.id) {
                this.errorMessage = 'Please select a weekday.';
                this.errorField = 7;
                return false;
            }
        } else {
            this.errorField = 2;
            this.errorMessage = 'Please enter valid data.';
            return false;
        }
        return true;
    }

    private validateMonthlyData(): boolean {
        this.clearValidationMsg();
        if (Object.keys(this.monthlyData).length) {
            if (this.monthlyData.isDay) {
                if (isNaN(this.monthlyData.dayNumber) || !+this.monthlyData.dayNumber || +this.monthlyData.dayNumber > 31) {
                    this.errorMessage = 'Please enter a valid day.';
                    this.errorField = 3;
                    return false;
                }

                if (!+this.monthlyData.dayMonth || (this.monthlyData.dayMonth && isNaN(this.monthlyData.dayMonth))) {
                    this.errorMessage = 'Please enter a valid month.';
                    this.errorField = 4;
                    return false;
                }

                if (+this.monthlyData.dayNumber > 28 && !this.isInfoMsgAccepted) {
                    this.showInfoPopup = true;
                    return false;
                }
            } else {
                if (!this.selectedWeek || !this.selectedWeek.id) {
                    this.errorMessage = 'Please select week.';
                    this.errorField = 6;
                    return false;
                }
                if (!this.selectedWeekday || !this.selectedWeekday.id) {
                    this.errorMessage = 'Please select weekday.';
                    this.errorField = 7;
                    return false;
                }
                if (!+this.monthlyData.weekMonths || isNaN(this.monthlyData.weekMonths)) {
                    this.errorMessage = 'Please enter a valid month.';
                    this.errorField = 5;
                    return false;
                }
            }
            return true;
        }
        this.errorMessage = 'Please enter valid data.';
        return false;
    }

    private resetToDefault() {
        this.showWeekdayDropdownList = false;
        this.showWeekDropdownList = false;
        this.startTime = new Date().toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });

        this.dailyData = { isEveryWeekDay: false, days: null } as DailyData;
        this.weeklyData = {} as WeeklyData;
        this.monthlyData = { isDay: true } as MonthlyData;
        this.isInfoMsgAccepted = false;
        this.clearValidationMsg();
    }

    private getDefaultWeekday() {
        const weekday = new Date().toLocaleString('en-US', { weekday: 'long' });
        return this.weekdayItems.find(wdi => wdi.name === weekday) || this.weekdayItems[0];
    }

    private getDefaultWeek() {
        let weekCount = 0;
        let hasExtraDays = false;
        for (let i = 1; i <= new Date().getDate(); i++) {
            const weekday = new Date(new Date().setDate(i)).toLocaleString('en-US', { weekday: 'short' });
            if (weekday === 'Sat') {
                hasExtraDays = false;
                weekCount++;
            } else {
                hasExtraDays = true;
            }
        }
        if (hasExtraDays) {
            weekCount++;
        }
        return this.weekItems.find(wi => wi.id === weekCount) || this.weekItems[0];
    }
}